/**
 * API service functions for public chat functionality
 * Handles retrieving shared chat data from the server
 */
import {services} from '../../../api';
import type {MessageItem} from '../../../interfaces/reducers/chat';
import type {MessageItemType} from '../../../interfaces/api/qna';

/**
 * Retrieves chat history for a publicly shared chat
 * @param chatId - The unique identifier for the shared chat
 * @returns Promise containing mapped chat messages and links metadata
 */
export const getChats = async (
  chatId: string,
): Promise<{messages: MessageItem[]; metadata: any}> => {
  try {
    const res = await services.share.getChatHistory(chatId);
    const apiMessages: MessageItemType[] = (res as any)?.content?.model?.messages || [];
    const linksMeta = (res as any)?.content?.links_meta || undefined;

    const mapped: MessageItem[] = apiMessages.map(m => ({
      id: String(m.id),
      message: m.content,
      sender_id: m.user_id !== undefined && m.user_id !== null ? String(m.user_id) : undefined,
      role: m.role,
      thread_id: String(m.thread_id || ''),
      created_at: m.created_at,
      updated_at: m.updated_at,
      images: [],
      sender_name: m.role === 'user' ? 'You' : 'Genio',
    }));

    return {messages: mapped, metadata: linksMeta};
  } catch (ex) {
    return {messages: [], metadata: undefined};
  }
};
